/* Almla redesign: homepage behaviour, ported from the Cortex Page Builder home design.
   Hero slider, photo rails and the Almla on You hotspots. */

(function(){
  var bnr = document.querySelector("[data-bnr]");
  if (!bnr) return;
  var slides = [].slice.call(bnr.querySelectorAll(".bnr-slide"));
  var dots = bnr.querySelector("[data-bnr-dots]");
  var i = 0;
  var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  slides.forEach(function(_, n){
    var b = document.createElement("button");
    b.type = "button"; b.setAttribute("role","tab");
    b.setAttribute("aria-label", "Banner " + (n + 1));
    b.setAttribute("aria-selected", String(n === 0));
    b.addEventListener("click", function(){ go(n); rest(); });
    dots.appendChild(b);
  });

  function go(n){
    i = (n + slides.length) % slides.length;
    slides.forEach(function(s, k){ s.classList.toggle("is-on", k === i); });
    [].forEach.call(dots.children, function(d, k){ d.setAttribute("aria-selected", String(k === i)); });
  }
  // No autoplay (client feedback, Oct 13: the moving banners felt glitchy).
  // Banners change only by the dots or a swipe.
  function rest(){}

  // Swipe between banners (client feedback, Oct 13). The slide follows the
  // finger with its neighbour alongside, then glides into place; a short or
  // mostly vertical drag springs back and the page scrolls as usual.
  var track = bnr.querySelector(".bnr-slides");
  if (track && slides.length > 1) {
    var x0 = 0, y0 = 0, dx = 0, t0 = 0, mode = "", nb = null, busy = false;
    function pose(el, x, ms){
      el.style.transition = ms ? "transform " + ms + "ms cubic-bezier(.22,.7,.2,1)" : "none";
      el.style.opacity = "1";
      el.style.transform = "translate3d(" + x + "px,0,0)";
    }
    function clear(el){ el.style.transition = "none"; el.style.transform = ""; el.style.opacity = ""; }
    track.addEventListener("touchstart", function(e){
      if (busy || e.touches.length > 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; t0 = Date.now(); mode = ""; nb = null;
    }, {passive:true});
    track.addEventListener("touchmove", function(e){
      if (busy || mode === "y") return;
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (!mode) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        mode = Math.abs(mx) > Math.abs(my) ? "x" : "y";
        if (mode === "y") return;
      }
      dx = mx;
      var w = track.offsetWidth, want = slides[(i + (dx < 0 ? 1 : -1) + slides.length) % slides.length];
      if (nb && nb !== want) clear(nb);
      nb = want;
      pose(slides[i], dx, 0);
      pose(nb, dx + (dx < 0 ? w : -w), 0);
    }, {passive:true});
    function end(){
      if (mode !== "x" || !nb) { mode = ""; return; }
      var w = track.offsetWidth, cur = slides[i], fast = Math.abs(dx) / Math.max(1, Date.now() - t0) > 0.35;
      var commit = Math.abs(dx) > w * 0.22 || (fast && Math.abs(dx) > 24);
      var dir = dx < 0 ? 1 : -1, ms = still ? 0 : 340;
      busy = true;
      pose(cur, commit ? -dir * w : 0, ms);
      pose(nb, commit ? 0 : dir * w, ms);
      setTimeout(function(){
        clear(cur); clear(nb);
        if (commit) go(i + dir);
        void track.offsetWidth;
        cur.style.transition = ""; nb.style.transition = "";
        busy = false; mode = "";
      }, ms + 20);
    }
    track.addEventListener("touchend", end, {passive:true});
    track.addEventListener("touchcancel", end, {passive:true});
    // A swipe that ends over the button is not a tap on it.
    track.addEventListener("click", function(e){ if (Math.abs(dx) > 8 && mode === "x") e.preventDefault(); }, true);
  }
  rest();

})();


document.querySelectorAll('[data-rail]').forEach(function(w){
  var rail=w.querySelector('.rail'), prev=w.querySelector('.rnav--prev'), next=w.querySelector('.rnav--next');
  if(!rail) return;
  function step(){ var c=rail.querySelector(':scope > *'); return c? c.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).columnGap||16):320; }
  function sync(){ if(!prev) return;
    prev.disabled = rail.scrollLeft<8;
    next.disabled = rail.scrollLeft > rail.scrollWidth-rail.clientWidth-8; }
  prev&&prev.addEventListener('click',function(){rail.scrollBy({left:-step()*2,behavior:'smooth'});});
  next&&next.addEventListener('click',function(){rail.scrollBy({left: step()*2,behavior:'smooth'});});
  rail.addEventListener('scroll',sync,{passive:true}); sync();
});


// As Seen on You: one hotspot per photo, opening the tagged product.
document.addEventListener("click", function(e){
  var dot = e.target.closest(".ugc-dot");
  if (!dot) {
    if (!e.target.closest(".ugc-tag")) {
      document.querySelectorAll(".ugc-tag.is-open").forEach(function(t){
        t.classList.remove("is-open");
        t.parentNode.querySelector(".ugc-dot").setAttribute("aria-expanded","false");
      });
    }
    return;
  }
  var shot = dot.closest(".ugc-shot"), tag = shot.querySelector(".ugc-tag"), on = !tag.classList.contains("is-open");
  document.querySelectorAll(".ugc-tag.is-open").forEach(function(t){
    t.classList.remove("is-open");
    t.parentNode.querySelector(".ugc-dot").setAttribute("aria-expanded","false");
  });
  tag.classList.toggle("is-open", on);
  dot.setAttribute("aria-expanded", String(on));
});

/* Rails with arrows (product lanes and review rows). They no longer move on
   their own (client feedback, Oct 13: "lets get rid of the moving carousels");
   the arrows step one card at a time and loop, and a swipe scrolls as usual.
   A rail with nothing to scroll (e.g. Back in Stock with three pairs) hides
   its arrows and centres its cards. data-ar-reverse starts a rail at its end. */
(function(){
  [].forEach.call(document.querySelectorAll("[data-autorail]"), function(w){
    var t = w.querySelector("[data-ar-track]");
    if (!t) return;
    var rev = w.hasAttribute("data-ar-reverse");
    function step(){
      var c = t.firstElementChild;
      if (!c) return 300;
      var gap = parseFloat(getComputedStyle(t).columnGap) || 16;
      return c.getBoundingClientRect().width + gap;
    }
    function max(){ return Math.max(0, t.scrollWidth - t.clientWidth - 2); }
    function go(dir){
      if (dir > 0 && t.scrollLeft >= max()) t.scrollTo({ left: 0, behavior: "smooth" });
      else if (dir < 0 && t.scrollLeft <= 2) t.scrollTo({ left: max() + 2, behavior: "smooth" });
      else t.scrollBy({ left: step() * dir, behavior: "smooth" });
    }
    var prev = w.querySelector("[data-ar-prev]"), next = w.querySelector("[data-ar-next]");
    if (prev) prev.addEventListener("click", function(){ go(-1); });
    if (next) next.addEventListener("click", function(){ go(1); });
    function fit(){ w.classList.toggle("is-static", t.scrollWidth - t.clientWidth <= 4); }
    fit();
    window.addEventListener("resize", fit);
    window.addEventListener("load", fit);
    if (rev) window.addEventListener("load", function(){ t.scrollLeft = max(); });
  });
})();

/* Shop by Collection: phones show the first six with a "See more" button. */
(function(){
  var btn = document.querySelector("[data-cgrid-more]"), grid = document.querySelector("[data-cgrid]");
  if (!btn || !grid) return;
  btn.addEventListener("click", function(){
    var all = grid.classList.toggle("is-all");
    btn.setAttribute("aria-expanded", all);
    btn.textContent = all ? "Show fewer collections" : "See more collections";
  });
})();
/* Value props on phones and tablets: one smooth, endless left-to-right
   ticker (client feedback, Oct 13). The set is repeated once (hidden from
   screen readers) and the row travels exactly one set, so the loop has no
   seam. Speed is per pixel, so it reads the same at any width. Reduced
   motion keeps the swipe row with its dots below. Desktop shows one row. */
(function(){
  var list = document.querySelector(".props--row .proplist");
  if (!list || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  [].slice.call(list.children).forEach(function(li){
    var c = li.cloneNode(true);
    c.setAttribute("aria-hidden", "true");
    c.setAttribute("data-clone", "");
    c.removeAttribute("data-shopify-editor-block");
    list.appendChild(c);
  });
  list.classList.add("is-marq");
  function speed(){ list.style.setProperty("--marq-s", Math.max(12, list.scrollWidth / 2 / 34) + "s"); }
  speed();
  window.addEventListener("resize", speed);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(speed);
})();
/* Value props with reduced motion: a dot per pair of props, following the swipe. */
(function(){
  var list = document.querySelector(".props--row .proplist");
  if (!list || list.classList.contains("is-marq")) return;
  var dots = document.createElement("div");
  dots.className = "prop-dots";
  dots.setAttribute("aria-hidden", "true");
  list.parentNode.appendChild(dots);
  // One dot per screenful: props in view at once, rounded up over the list.
  function pages(){
    var li = list.firstElementChild;
    if (!li) return 1;
    var per = Math.max(1, Math.floor((list.clientWidth + 12) / (li.getBoundingClientRect().width + 12)));
    return Math.ceil(list.children.length / per);
  }
  function draw(){
    var n = pages(), on = Math.round(list.scrollLeft / Math.max(1, list.scrollWidth - list.clientWidth) * (n - 1)) || 0;
    if (dots.children.length !== n) dots.innerHTML = new Array(n + 1).join("<i></i>");
    [].forEach.call(dots.children, function(d, k){ d.classList.toggle("is-on", k === on); });
    dots.style.visibility = n > 1 ? "" : "hidden";
  }
  list.addEventListener("scroll", draw, { passive: true });
  window.addEventListener("resize", draw);
  draw();
})();
